export default __webpack_public_path__ + "static/media/map-pin.b59a59d0.svg";